import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as apiSelectors from 'modules/api/selectors';
import { clearResults, symbolConfigRequest } from '../actions';
import TradingCalculators from '../components/TradingCalculators';
import { LEVERAGE_VALUES } from '../constants';
import * as selectors from '../selectors';
import * as authSelectors from '../../auth/selectors';
import { getCountryByIpRequest } from 'modules/geolocation/actions';
import { isAsicRegulator } from 'helpers/regulators';

import { store } from 'components/App';

const TradingCalculatorsContainer = ({ isPublic, regulator }) => {
  useEffect(() => {
    import('../sagas').then((saga) => {
      store.injectSaga('TradingCalculators', saga.default);
    });
  }, []);

  const [leverageValues, setLeverageValues] = useState([]);
  const [leverageDisabled, setLeverageDisabled] = useState(false);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(symbolConfigRequest());
    dispatch(getCountryByIpRequest());
  }, [dispatch]);

  useSelector(selectors.getSymbolConfig);
  const symbols = useSelector(selectors.getSymbolConfig);
  const isRetailUser = useSelector(authSelectors.isRetailUser);

  useEffect(() => {
    let leverage = LEVERAGE_VALUES;
    let leverageDisabled = false;

    if (
      // for static site leverage should be 30 for AU
      (isPublic && isAsicRegulator(regulator)) ||
      // for the hub leverage should be 30 if user is retail
      (!isPublic && isRetailUser)
    ) {
      leverage = LEVERAGE_VALUES.filter((value) => value.value <= 30);
      leverageDisabled = true;
    }

    setLeverageValues(leverage);
    setLeverageDisabled(leverageDisabled);
  }, [isRetailUser, isPublic, regulator]);

  const isSymbolConfigLoading = useSelector(
    apiSelectors.createPendingSelector(symbolConfigRequest),
  );

  const handleNavTabChange = useCallback(() => dispatch(clearResults()), [dispatch]);

  return (
    <TradingCalculators
      isPublic={isPublic}
      regulator={regulator}
      leverageValues={leverageValues}
      symbols={symbols}
      loading={isSymbolConfigLoading}
      onNavTabChange={handleNavTabChange}
      leverageDisabled={leverageDisabled}
    />
  );
};

export default TradingCalculatorsContainer;
